    import React from 'react';
    import { UserAgentApplication } from 'msal';
    import { cofiguration } from '../AzureIntegration/Config';
    import { connect } from 'react-redux';
    import { withRouter } from 'react-router-dom';
    import ErrorMessage from './ErrorMessage';
//    import { authenticateUser } from "../Actions/UserManageAPI";
    var graph = require('@microsoft/microsoft-graph-client');
    class Login extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                IsAuthenticatedUser: true
            };
            this.authMethod = this.authMethod.bind(this);
            this.userAgentApplication = new UserAgentApplication({
                auth: {
                    clientId: '1d20239c-928c-486e-9cbc-6ad2f89d796b',
                    redirectUri: 'http://localhost:3000/',
                    authority: "https://login.microsoftonline.com/9b995efe-255d-496c-b7bf-efc3ae8d8192"
                },
                cache: {
                    cacheLocation: "sessionStorage",
                    storeAuthStateInCookie: true
                }
            });
            this.userAgentApplication.handleRedirectCallback((error, response) => {
            });
        }
        static getDerivedStateFromProps(nextProps, prevState) {
            const { dispatch } = nextProps;  
            
            if(nextProps.IsAuthenticatedUser == false)
            {
                
                if(nextProps.location.pathname!='/Error')
                {
                prevState.IsAuthenticatedUser = true;
                nextProps.history.push("/Error");
                let normalizedError = {
                    message: "Access Denied",
                    debug: "You Need Access to Sign in this Application..."
                };
                dispatch({
                    type: "ErrorMessage",
                    data: normalizedError
                });
            }
            }
                
            
        }
        componentDidMount() {
            // this.props.dispatch({ type: "ShowRightPan", data: true });
            // If MSAL already has an account, the user
            // is already logged in
            //this.props.history.push("/Home")
            var account = this.userAgentApplication.getAccount();
            if (account && account != null) {
                // Enhance user object with data from Graph
                this.getUserProfile();
            }
            else
                this.authMethod()
        }

        async authMethod() {
            try {
                // Login via popup
                await this.userAgentApplication.loginRedirect(
                    {
                        scopes: [
                            'user.read',
                            'openid',
                            'profile'
                        ],
                        prompt: "select_account"
                    });
                // After login, get the user's profile
                //this.getUserProfile();
            }
            catch (err) {
                let { dispatch } = this.props;
                let errorlist = await this.normalizeError(err);
                this.props.history.push('/Error');
                dispatch({
                    type: "ErrorMessage",
                    data: errorlist
                })
                return (
                    <ErrorMessage errorlist={errorlist} />);
            }
        }
        async getUserProfile() {
            
            let { dispatch } = this.props;
            try {
                this.props.history.push("/Home/ClientDashboard")
                // var accessToken = await this.getAccessToken([
                //     'user.read',
                //     "openid",
                //      "profile"
                // ])
                var account = this.userAgentApplication.getAccount();

                if (account) {
                    // Get the user's profile from Graph
                    //  var orgUsers=await this.getMyOrganizationUsers(accessToken);
                    var user = {
                        displayName: account.name,
                        mail: account.userName
                    }
                    let userData = {
                        isAuthenticated: true,
                        displayName: account.displayName,
                        user: {
                            displayName: account.name,
                            email: account.userName
                        },
                        error: null
                    }
                    if (user) {
                    //    dispatch(authenticateUser(user.mail));
                    }
                    
                    dispatch({
                        type: "AuthenticatedUserInformation",
                        data: userData
                    });

                }
            }
            catch (err) {
                let errorlist = await this.normalizeError(err);
                return (
                    <ErrorMessage errorlist={errorlist} />);

            }
        }
        async getAccessToken(scopes) {
            try {
                // Get the access token silently
                // If the cache contains a non-expired token, this function
                // will just return the cached token. Otherwise, it will
                // make a request to the Azure OAuth endpoint to get a token
                var silentResult = await this.userAgentApplication.acquireTokenSilent({
                    scopes: scopes
                });

                return silentResult.accessToken;
            } catch (err) {
                // If a silent request fails, it may be because the user needs
                // to login or grant consent to one or more of the requested scopes
                // if (this.isInteractionRequired(err)) {
                console.log(err);
                var interactiveResult = this.userAgentApplication.acquireTokenPopup({
                    scopes: scopes
                });

                return interactiveResult.accessToken;
                // } else {
                //     throw err;
                // }
            }
        }
        async getMyOrganizationUsers(accessToken) {
            const client = this.getAuthenticatedClient(accessToken);
            const user = await client.api('/users').get();
            return user;
        }
        async getUserDetails(accessToken) {
            const client = this.getAuthenticatedClient(accessToken);
            const user = await client.api('/me').get();
            return user;
        }
        getAuthenticatedClient(accessToken) {
            // Initialize Graph client
            const client = graph.Client.init({
                // Use the provided access token to authenticate
                // requests
                authProvider: (done) => {
                    done(null, accessToken);
                }
            });

            return client;
        }
        normalizeError(error) {
            var normalizedError = {};
            if (typeof (error) === 'string') {
                var errParts = error.split('|');
                normalizedError = errParts.length > 1 ?
                    { message: errParts[1], debug: errParts[0] } :
                    { message: error };
            } else {
                normalizedError = {
                    message: error.message,
                    debug: JSON.stringify(error)
                };
            }
            return normalizedError;
        }

        render() {

            return (
                <div></div>
            )
        }
    }
    function mapDispatchToProps(dispatch) {
        return {
            dispatch,
        }
    }
    function mapStateToProps(state) {
        // if(state.SidePanReducer.IsAuthenticatedUser)
        // {
        //     return {
        //         IsAuthenticatedUser: state.SidePanReducer.IsAuthenticatedUser
        //     }
        // }
        // else if(state.SidePanReducer.IsAuthenticatedUser === false)
        // {
        //     ;
        //     return {
        //         IsAuthenticatedUser: false
        //     }
        // }
        
    }
    export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
